import script from "./CompanyToChoose.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyToChoose.vue?vue&type=script&setup=true&lang=js"

import "./CompanyToChoose.vue?vue&type=style&index=0&id=1e2a48d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e2a48d2"]])

export default __exports__